import { withIconWrapper } from 'hocs/withIconWrapper';

import { ReactComponent } from './BurgerIcon.c.svg';

export const BurgerIcon = withIconWrapper(ReactComponent);
